import type { FC } from 'react';

import * as styles from './AgeLimitLabel.module.scss';

type Props = {
  ageLimit?: number | null;
};

const AgeLimitLabel: FC<Props> = ({ ageLimit }) => {
  if (ageLimit === null || ageLimit === undefined) {
    return null;
  }

  const label = ageLimit === 0 ? 'A' : ageLimit;

  return <span className={styles.ageLimit}>{label}</span>;
};

export { AgeLimitLabel };
